export default __webpack_public_path__ + "8404af9099167c5f97980f1391bc586b.svg";